import { render } from "./HeroiconsOutlineClipboardList.vue?vue&type=template&id=f9d1eb40"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineClipboardList.vue"]])

export default __exports__